(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.ay [data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    els.forEach(function(el){ if (el.dataset.delay) el.style.transitionDelay = el.dataset.delay + 'ms'; io.observe(el); });
  }
  if (reduce) return;

  var canvas = document.querySelector('.ay-hero canvas');
  if (canvas && canvas.getContext) {
    var ctx = canvas.getContext('2d'), w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), P = [], visible = true;
    var size = function(){ w = canvas.clientWidth; h = canvas.clientHeight; canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    var add = function(x, y, burst){ P.push({ x: x, y: y, r: Math.random() * 1.9 + 0.4, vx: (Math.random() - 0.5) * (burst ? 1.8 : 0.3), vy: -(Math.random() * 0.6 + 0.15) * (burst ? 2 : 1), life: 0, max: 120 + Math.random() * 180, tw: Math.random() * 6.28 }); };
    size();
    window.addEventListener('resize', size);
    for (var i = 0; i < 80; i++) add(Math.random() * w, Math.random() * h);
    canvas.parentElement.addEventListener('pointermove', function(e){ var r = canvas.getBoundingClientRect(); for (var k = 0; k < 2; k++) add(e.clientX - r.left, e.clientY - r.top, true); });
    new IntersectionObserver(function(en){ visible = en[0].isIntersecting; }).observe(canvas);
    (function loop(){
      requestAnimationFrame(loop);
      if (!visible) return;
      ctx.clearRect(0, 0, w, h);
      if (P.length < 110 && Math.random() < 0.35) add(Math.random() * w, h + 4);
      for (var j = P.length - 1; j >= 0; j--) {
        var p = P[j]; p.x += p.vx; p.y += p.vy; p.life++; p.tw += 0.08;
        if (p.life > p.max) { P.splice(j, 1); continue; }
        var a = Math.sin(Math.PI * p.life / p.max) * (0.55 + 0.45 * Math.sin(p.tw));
        ctx.globalAlpha = Math.max(a, 0);
        ctx.fillStyle = '#F3D58A';
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        if (p.r > 1.7) { ctx.strokeStyle = '#FFF4D6'; ctx.lineWidth = 0.6; ctx.beginPath(); ctx.moveTo(p.x - p.r * 3.5, p.y); ctx.lineTo(p.x + p.r * 3.5, p.y); ctx.moveTo(p.x, p.y - p.r * 3.5); ctx.lineTo(p.x, p.y + p.r * 3.5); ctx.stroke(); }
      }
      ctx.globalAlpha = 1;
    })();
  }

  document.querySelectorAll('.ay [data-tilt]').forEach(function(card){
    card.addEventListener('pointermove', function(e){
      var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(900px) rotateY(' + (x * 12) + 'deg) rotateX(' + (-y * 12) + 'deg) translateY(-8px)';
      card.style.setProperty('--mx', (x + 0.5) * 100 + '%');
      card.style.setProperty('--my', (y + 0.5) * 100 + '%');
    });
    card.addEventListener('pointerleave', function(){ card.style.transform = ''; });
  });

  var media = document.querySelector('.ay-hero__media');
  if (media) {
    window.addEventListener('scroll', function(){ var y = window.scrollY; if (y < window.innerHeight) media.style.transform = 'translateY(' + (y * 0.3) + 'px)'; }, { passive: true });
  }
})();
